const responseStatus = {
  OK: "ok",
  ERROR: "error"
};

export default responseStatus;
